import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit';
import Fade from 'react-reveal/Fade';
import { arrowRight } from 'react-icons-kit/feather/arrowRight';
import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import NextImage from 'common/components/NextImage';
import Text from 'common/components/Text';
import PropTypes from 'prop-types';
import Link from 'common/components/Link';
import { format } from 'date-fns';
import { createClient } from '../../../../prismicio';
import { Section, SectionHeading, Grid, Article } from './LatestBlog.style';

const LatestBlog = ({ imageStyle }) => {
  const [latestArticles, setLatestArticles] = useState([]);

  useEffect(() => {
    const fetchLatestArticles = async () => {
      const client = createClient();
      const articles = await client.getAllByType('article', {
        limit: 3,
        orderings: [{ field: 'my.article.published_date', direction: 'desc' }],
      });
      setLatestArticles(articles);
    };

    fetchLatestArticles();
  }, []);
  return (
    <Section>
      <Container>
        <SectionHeading>
          <Heading content="Recent Articles" />
        </SectionHeading>
        <Grid>
          {latestArticles.map((article) => {
            const published_date = new Date(article.data.published_date);
            const formatedDate = format(published_date, 'MMM dd, yyyy');
            return (
              <Link
                href={`/blog/${article.uid}`}
                style={{ textDecoration: 'none' }}
              >
                <Fade key={article.id} up delay={article.id * 100}>
                  <Article>
                    <NextImage
                      style={imageStyle}
                      field={article.data.hero_image}
                    />
                    <Text style={{ color: '#000' }} content={formatedDate} />
                    <Heading
                      as="h4"
                      style={{ color: '#000' }}
                      content={article.data.title}
                    />
                    <Link href={`/blog/${article.uid}`}>
                      {'Learn more'} <Icon icon={arrowRight} />
                    </Link>
                  </Article>
                </Fade>
              </Link>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
};
LatestBlog.propTypes = {
  imageStyle: PropTypes.object,
};
LatestBlog.defaultProps = {
  imageStyle: {
    width: 300,
    height: 200,
    borderRadius: '10px',
  },
};

export default LatestBlog;
